import api from './api.service';

export const roleService = {
    async list() {
        const resp = await api.get('/roles');
        return resp.data.data;
    },

    async get(id: string) {
        const resp = await api.get(`/roles/${id}`);
        return resp.data.data;
    },

    async create(data: { name: string; description?: string; permissionIds?: string[] }) {
        const resp = await api.post('/roles', data);
        return resp.data.data;
    },

    async update(id: string, data: { name?: string; description?: string; permissionIds?: string[] }) {
        const resp = await api.patch(`/roles/${id}`, data);
        return resp.data.data;
    },

    async delete(id: string) {
        const resp = await api.delete(`/roles/${id}`);
        return resp.data;
    },

    async getPermissions() {
        const resp = await api.get('/roles/permissions');
        return resp.data.data;
    },
};